import { createApp } from 'vue'
import FSlider from '~/js/components/slider'
import FProductCard from '~/js/components/productCard'
import FTab from '~/js/components/tab'
import FTabWrapped from '~/js/components/tabWrapped'
import { fetchVisibleCollectionProducts } from '~/js/helpers/storefront/collectionProducts'
import { isDesktop } from '~/js/templates/index/helpers'
import { TabItem } from '~/js/models/tabItem'
import { isIndexPage } from '~/js/helpers/page-helper'

const CLASS_NAME = 'js-sectionsCollectionItems'
const PAGE_SIZE = 20

const fetchCollectionProducts = async ({
  collectionId,
  storefrontAccessToken,
  limit,
}) => {
  return fetchVisibleCollectionProducts({
    collectionId,
    storefrontAccessToken,
    limit,
    pageSize: PAGE_SIZE,
  })
}

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(CLASS_NAME)
  if (!elements.length) return

  Array.from(elements).forEach(async (element) => {
    const collectionIds = JSON.parse(element.dataset.collectionIds)
    const columnsSp = Number(element.dataset.columnsSp)
    const linkTexts = JSON.parse(element.dataset.linkTexts)
    const linkUrls = JSON.parse(element.dataset.linkUrls)
    const productLinkParams = JSON.parse(element.dataset.productLinkParams).map(
      (string) => JSON.parse(string || '{}')
    )
    const storefrontAccessToken = element.dataset.storefrontAccessToken || ''
    const tabItemTitles = JSON.parse(element.dataset.tabItemTitles)

    const productCount = isDesktop()
      ? Number(element.dataset.productCountPc)
      : Number(element.dataset.productCountSp)

    if (!storefrontAccessToken) return

    const selectedIndex = 0
    const tabItems = tabItemTitles.map((title, index) => {
      const isSelected = index === selectedIndex
      return new TabItem({ title, isSelected })
    })

    createApp({
      name: 'SectionsCollectionItems',
      components: {
        FSlider,
        FProductCard,
        FTab,
        FTabWrapped,
      },
      data() {
        return {
          collectionIds,
          isDesktop: isDesktop(),
          linkUrls,
          linkTexts,
          productLinkParams,
          products: [],
          selectedIndex,
          showReview: !isIndexPage,
          showCartButton: !isIndexPage,
          sliderItemsChanged: false,
          tabItems,
        }
      },
      computed: {
        narrow() {
          return !this.isDesktop && columnsSp > 2
        },
      },
      watch: {
        async selectedIndex() {
          await this.setProducts()
          this.sliderItemsChanged = true
        },
      },
      async created() {
        await this.setProducts()
        this.sliderItemsChanged = true
      },
      methods: {
        async setProducts() {
          // 今、選択されているコレクション
          const collectionId = collectionIds[this.selectedIndex]

          this.products = await fetchCollectionProducts({
            collectionId,
            storefrontAccessToken,
            limit: productCount,
          })

          this.$nextTick(() => {
            window.zvRenderReviewSummary(element)
          })
        },
        onTabItemClicked(index) {
          this.selectedIndex = index
          this.tabItems.forEach(
            (tabItem, i) => (tabItem.isSelected = i === index)
          )
        },
      },
    }).mount(element)
  })
})
